<template>
  <div class="main-container">
    <div class="none-start-parts" v-if="isNoneStartFlag">
      開始設定されていないため、デモ再生ができません。
    </div>
    <div
      class="tark-box disp-scroll"
      @mouseenter="demoPlay()"
      @mouseleave="demoStop()"
      v-else-if="demoTalk.length > 0 && !isNoneStartFlag"
      ref="demo_chat"
    >
      <div
      v-for="talk, index in getDispTalkList"
      :key="talk.beforenode + '-' + index"
        class="chat-timeline"
        :class="{ 'other-timeline': talk.speaker === 'other', 'my-timeline': talk.speaker === 'my' }"
      >
        <div class="avatar-box" :class="talk.speaker" v-if="talk.disp==='disp'">
          <!-- アイコン -->
          <img :src="iconUrl(talk)" />
        </div>
        <div class="balloon-box" v-if="talk.disp==='disp'">
          <div
            class="message-box"
            :class="{ 'other-message-box': talk.speaker === 'other', 'my-message-box': talk.speaker === 'my' }"
            :style="{
            'background' : talk.speaker==='other' ? color.balloonMy : color.balloonOtr + '!important',
            'color'      : autoColor(talk.speaker==='other' ? color.balloonMy : color.balloonOtr),
            'filter'     : shadowStyle(color.shadowType)}"
          >
            <!-- 選択肢ありパーツ -->
            <div
              class="select-balloon"
              :class="{ 'other-box': talk.speaker === 'other', 'my-box': talk.speaker === 'my' }"
              v-if="talk.status===0"
            >
              <div
                class="message"
                :style="{
                  background: talk.speaker === 'other' ? color.balloonMy : color.balloonOtr + '!important',
                  color: autoColor(talk.speaker === 'other' ? color.balloonMy : color.balloonOtr),
                }"
              >
                <p class="message-title">{{ messageCreate(talk.mainmessage) }}</p>
                <div
                  class="select-button-box"
                  v-for="(choice, choiceIndex) in talk.select"
                  :key="talk.beforenode + '-' + choice.message"
                >
                  <button
                    v-if="buttonCreate(choice.message) !== ''"
                    class="message-button"
                    :class="['slide-button-' + choice.message + '-' + String(choiceIndex), {
                      'is-info': colorCreate(choice.text_option) === 'Blue',
                      'is-warning': colorCreate(choice.text_option) === 'Yellow',
                      'is-danger': colorCreate(choice.text_option) === 'Red'
                    }]"
                    disabled
                  >
                  {{ buttonCreate(choice.message) }}
                  </button>
                </div>
              </div>
            </div>
            <!-- 応募フォームパーツ -->
            <div
              class="application-balloon"
              :class="{ 'other-box': talk.speaker === 'other', 'my-box': talk.speaker === 'my' }"
              v-if="talk.status===1"
            >
              <div
                class="message"
                :style="{
                  background: talk.speaker === 'other' ? color.balloonMy : color.balloonOtr + '!important',
                  color: autoColor(talk.speaker === 'other' ? color.balloonMy : color.balloonOtr),
                }"
              >
                <p class="message-title">
                  {{messageCreate(talk.mainmessage)}}
                </p>
                <div class="application-box">
                  <div class="application-header">
                    <p><span class="mdi mdi-file-document-box-outline" style="margin-right: 4px; font-size: 14px;"></span>入力フォーム</p>
                  </div>
                  <div class="application-body">
                    <div class="application-form">
                      <p class="application-title">お名前</p>
                      <input class="-right-8px name-input-size" placeholder="山田" disabled />
                    </div>
                    <div class="application-form">
                      <p class="application-title">Email</p>
                      <input class="email-input-size" placeholder="taro-yamada@xxx.yyy.jp" type="email" disabled />
                    </div>
                    <div class="application-form">
                      <p class="application-title">TEL</p>
                      <input class="-left-8px tel-input-size" placeholder="080"  type="tel" disabled />
                    </div>
                    <div class="button-container">
                      <button
                        class="button is-small message-button"
                        disabled
                      >
                        <span class="mdi mdi-send" style="margin-right: 4px;"></span>送信する
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- メッセージのみパーツ -->
            <div
              class="message-balloon"
              :class="{ 'other-box': talk.speaker === 'other', 'my-box': talk.speaker === 'my' }"
              v-if="talk.status===2"
            >
              <div
                class="message"
                :style="{
                  background: talk.speaker === 'other' ? color.balloonMy : color.balloonOtr + '!important',
                  color: autoColor(talk.speaker === 'other' ? color.balloonMy : color.balloonOtr),
                }"
              >
                <p class="message-title">{{ messageCreate(talk.mainmessage) }}</p>
              </div>
            </div>
            <!-- 日程自動調整パーツ -->
            <div
              class="calendar-balloon"
              :class="{ 'other-box': talk.speaker === 'other', 'my-box': talk.speaker === 'my' }"
              v-if="talk.status===4"
            >
              <div
                class="message"
                :style="{
                  background: talk.speaker === 'other' ? color.balloonMy : color.balloonOtr + '!important',
                  color: autoColor(talk.speaker === 'other' ? color.balloonMy : color.balloonOtr),
                }"
              >
                <p class="message-title">{{ messageCreate(talk.mainmessage) }}</p>
                <div class="calendar-box">
                  カレンダーが表示されます
                  <!-- <transition name="fade">
                    <b-datepicker
                      locale="ja-JP"
                      size="is-small"
                      disabled
                      inline
                    >
                    </b-datepicker>
                  </transition> -->
                </div>
              </div>
            </div>
            <!-- 画像 -->
            <div
              class="image-balloon"
              :class="{ 'other-box': talk.speaker === 'other', 'my-box': talk.speaker === 'my' }"
              v-if="talk.status===5"
            >
              <img :src="talk.imagePath">
            </div>
            <!-- 自由入力 -->
            <div
              class="free-input-balloon"
              :class="{ 'other-box': talk.speaker === 'other', 'my-box': talk.speaker === 'my' }"
              v-if="talk.status===6"
            >
              <div
                class="message"
                :style="{
                  background: talk.speaker === 'other' ? color.balloonMy : color.balloonOtr + '!important',
                  color: autoColor(talk.speaker === 'other' ? color.balloonMy : color.balloonOtr),
                }"
              >
                <p class="message-title">{{ messageCreate(talk.mainmessage) }}</p>
                <input
                  class="input input-on"
                  placeholder="内容"
                  disabled
                />
                <button
                  class="button is-small send-button"
                  disabled>
                  <span class="mdi mdi-send"></span>
                  送信'
                </button>
              </div>
            </div>
            <!-- ファイルアップロード -->
            <div
              class="file-upload-balloon"
              :class="{ 'other-box': talk.speaker === 'other', 'my-box': talk.speaker === 'my' }"
              v-if="talk.status===7"
            >
              <div
                class="message"
                :style="{
                  background: talk.speaker === 'other' ? color.balloonMy : color.balloonOtr + '!important',
                  color: autoColor(talk.speaker === 'other' ? color.balloonMy : color.balloonOtr),
                }"
              >
                <p class="message-title">ファイルをアップロードしてください。</p>
                <button class="button is-small message-button" disabled>
                  送信
                </button>
              </div>
            </div>
            <!-- 履歴書フォーム -->
            <div
              class="resume-balloon"
              :class="{ 'other-box': talk.speaker === 'other', 'my-box': talk.speaker === 'my' }"
              v-if="talk.status===8"
            >
              <div class="resume-box">
                <!-- header -->
                <header class="resume-header">
                  <h1 class="-title">履歴書フォーム</h1>
                </header>
                <!-- フォーム -->
                <b-steps
                  size="is-small"
                  :animated="true"
                  :rounded="true"
                  :has-navigation="true"
                  label-position="bottom"
                  mobile-mode="compact"
                >
                  <!-- 基本 -->
                  <b-step-item step="1" label="基本情報" :clickable="false">
                    <div class="form-box">
                      <p>氏名（必須）</p>
                      <input class="input is-small name-input-size" placeholder="履歴書 太郎" disabled />
                      <p>ふりがな（必須）</p>
                      <input
                        class="input is-small name-input-size"
                        placeholder="りれきしょ たろう"
                        disabled
                      />
                      <p>性別（必須）</p>
                      <b-field>
                        <input
                          type="radio"
                          name="sex"
                          value="1"
                          class="radio-input is-small radio-input-size"
                          id="radio-01"
                          disabled
                        />
                        <label for="radio-01">男性</label>
                        <input
                          type="radio"
                          name="sex"
                          value="2"
                          class="radio-input is-small radio-input-size"
                          id="radio-02"
                          disabled
                        />
                        <label for="radio-02">女性</label>
                      </b-field>
                      <b-field>
                        <input
                          type="radio"
                          name="sex"
                          value="3"
                          class="radio-input is-small radio-input-size"
                          id="radio-03"
                          disabled
                        />
                        <label for="radio-03">選択しない</label>
                      </b-field>
                      <p>生年月日（必須）</p>
                      <div class="calendar-box">
                        カレンダーが表示されます
                        <!-- <b-datepicker
                          inline
                          locale="ja-JP"
                          size="is-small"
                          placeholder="生年月日を設定"
                          icon="calendar-today"
                          disabled
                        >
                        </b-datepicker> -->
                      </div>
                    </div>
                  </b-step-item>
                </b-steps>
              </div>
            </div>
            <!-- チェックボックス -->
            <div
              class="checkbox-balloon"
              :class="{ 'other-box': talk.speaker === 'other', 'my-box': talk.speaker === 'my' }"
              v-if="talk.status===13"
            >
              <div
                class="message"
                :style="{
                  background: talk.speaker === 'other' ? color.balloonMy : color.balloonOtr + '!important',
                  color: autoColor(talk.speaker === 'other' ? color.balloonMy : color.balloonOtr),
                }"
              >
                <p class="message-title">{{ messageCreate(talk.mainmessage) }}</p>
                <div class="checkbox-container">
                  <div v-for="(item, index) in talk.parameter" :key="index">
                    <b-checkbox disabled>
                      {{messageCreate(item.item_message)}}
                    </b-checkbox>
                  </div>
                </div>
                <div class="field checkbox-button-wrapper">
                  <button class="button" disabled>送信</button>
                </div>
              </div>
            </div>
            <!-- 動画 -->
            <div
              class="movie-balloon"
              :class="{ 'other-box': talk.speaker === 'other', 'my-box': talk.speaker === 'my' }"
              v-if="talk.status===14"
            >
              <video
                id="movie-parts"
                :src="talk.movie_path"
                muted
                playsinline
                autoplay
              />
            </div>
            <!-- プルダウン -->
            <div
              class="pulldown-balloon"
              :class="{ 'other-box': talk.speaker === 'other', 'my-box': talk.speaker === 'my' }"
              v-if="talk.status===15"
            >
              <div
                class="message"
                :style="{
                  background: talk.speaker === 'other' ? color.balloonMy : color.balloonOtr + '!important',
                  color: autoColor(talk.speaker === 'other' ? color.balloonMy : color.balloonOtr),
                }"
              >
                <p class="message-title">{{ messageCreate(talk.mainmessage) }}</p>
                <div class="pulldown-box">
                  <div class="child-box">
                    <p class="item-box">
                      {{messageCreate(talk.title)}}
                    </p>
                    <b-select size="is-small">
                      <option>
                        {{messageCreate(talk.item)}}
                      </option>
                    </b-select>
                  </div>
                </div>
                <hr>
                <div class="field">
                  <button class="button is-fullwidth is-primary" disabled>
                    送信
                  </button>
                </div>
              </div>
            </div>
            <!-- カルーセル選択 -->
            <div
              class="carousel-select-balloon"
              :class="{ 'other-box': talk.speaker === 'other', 'my-box': talk.speaker === 'my' }"
              v-if="talk.status===17"
            >
              <carousel
                :navigationEnabled="true"
                :loop="true"
                :speed="250"
                navigation-prev-label="〈"
                navigation-next-label="〉"
                :paginationPadding = 2
                :per-page="1"
              >
                <slide v-for="(value ,index) in talk.parameter" :key="index">
                  <div class="slider-inner">
                    <div v-if="value.image_ref.image_data==''">
                      <img src="@/assets/template/no_image.svg">
                    </div>
                    <div v-else>
                      <img onerror="this.src='@/assets/template/no_image.svg'" :src="value.image_ref.image_data">
                    </div>
                    <section class="contents-container">
                      <div class="carousel-title">{{messageCreate(value.title)}}</div>
                      <div class="carousel-contents">{{messageCreate(value.contents)}}</div>
                      <button
                        disabled
                        class="button is-small is-primary is-fullwidth"
                      >
                        {{messageCreate(value.button)}}
                      </button>
                    </section>
                  </div>
                </slide>
              </carousel>
            </div>
            <!-- ファイルダウンロード -->
            <div
              class="file-download-balloon"
              :class="{ 'other-box': talk.speaker === 'other', 'my-box': talk.speaker === 'my' }"
              v-if="talk.status===18"
            >
              <div
                class="message"
                :style="{
                  background: talk.speaker === 'other' ? color.balloonMy : color.balloonOtr + '!important',
                  color: autoColor(talk.speaker === 'other' ? color.balloonMy : color.balloonOtr),
                }"
              >
                <p class="message-title">{{ messageCreate(talk.mainmessage) }}</p>
                <button
                  v-for="(m, index) in talk.parameter.attached_files"
                  :key="index"
                  class="message-button"
                  target="_blank" rel="noopener" :href="m[1]" download disabled>
                    <span class="mdi mdi-download -right-4px"></span>
                    {{ messageCreate(m[0]) }}
                </button>
                <hr>
                <div class="field">
                  <button class="message-button" disabled>
                    ダウンロード完了
                  </button>
                </div>
              </div>
            </div>
            <!-- 検索 -->
            <div
              class="search-balloon"
              :class="{ 'other-box': talk.speaker === 'other', 'my-box': talk.speaker === 'my' }"
              v-if="talk.status===20"
            >
              <div
                class="message"
                :style="{
                  background: talk.speaker === 'other' ? color.balloonMy : color.balloonOtr + '!important',
                  color: autoColor(talk.speaker === 'other' ? color.balloonMy : color.balloonOtr),
                }"
              >
                <div class="search-end-button">
                  <button
                    class="button is-small is-danger"
                    disabled
                  >
                    検索を終了
                  </button>
                </div>
                <p class="message-title" style="padding: 8px;">{{ messageCreate(talk.parameter.message) }}</p>
                <div class="search-box">
                  <input class="input is-small" disabled/>
                  <button
                    class="button is-info send-button is-small"
                    disabled
                  >
                    <span class="mdi mdi-magnify"></span>
                  </button>
                </div>
              </div>
            </div>
            <!-- PDFダウンロード -->
            <div
              class="pdf-download-balloon"
              :class="{ 'other-box': talk.speaker === 'other', 'my-box': talk.speaker === 'my' }"
              v-if="talk.status===21"
            >
              <div class="field">
                <button class="button message-button is-small">
                  {{messageCreate(talk.parameter.file_name)}}
                </button>
              </div>
              <hr>
              <div class="field">
                <button class="button message-button is-small">
                  ダウンロード完了
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState }    from 'vuex'
import controlLogMixin from '@/mixins/controlLogMixin'
import hex2rgb         from '@/functions/hex2rgb'
import {
  Carousel,
  Slide
} from 'vue-carousel'
import {
  autoColor,
  colorCreate,
  buttonCreate,
  shadowStyle,
} from '@/functions/balloonFunc'
import {
  // パーツ種別
  PARTS_STATUS,
} from '@/functions/robo/scenarioFunc'

export default {
  name: 'TemplateRoboScenarioDemo',
  componentName: 'TemplateRoboScenarioDemo',
  components: {
    Carousel,
    Slide
  },
  mixins: [
    controlLogMixin,
  ],
  props: {
    /**
     * テンプレートロボ
     * @type  {Object}
     */
    templateRobo: {
      type: Object,
      required: true
    },
  },
  computed: {
    ...mapState('chatbot', ['scenarioTable']),
    ...mapState('directtalk', ['color']),
    getDispTalkList() {
      return this.dispTalkList
    },
    isNoneStartFlag() {
      return this.noneStartFlag
    }
  },
  data () {
    return {
      /**
       * コンポーネント名
       * @type {String}
       */
      COMPONENT_NAME: 'TemplateRoboScenarioDemo',
      /**
       * 開始フラグ有無判定
       * @type {Boolean}
       */
      noneStartFlag: false,
      /**
       * デモ会話状態
       * @type {Boolean}
       */
      isDemoTalk: false,
      /**
       * デモ会話
       * @type {Array}
       */
      demoTalk: [],
      /**
       * デモ会話最終パーツ
       * @type {Object}
       */
      lastParts: null,
      /**
       * デモ進行タイマーID
       * @type {Object}
       */
      demoId: null,
      /**
       * 自動進行会話履歴
       * @type {Array}
       */
      dispTalkList: [],
    }
  },
  mounted () {
    // 最初のパーツを表示
    this.setFirstParts()
    this.scrollToTop()
  },
  watch :{
    demoTalk () {
      this.dispTalkList = this.demoTalk
    }
  },
  methods: {
    autoColor(c) {
      let color = hex2rgb(c)
      return autoColor(color)
    },
    shadowStyle(t) {
      return shadowStyle(t)
    },
    messageCreate (m) {
      if (m) {
        const pattern = /^\[.*\]|\[\/.*\]/g
        return m.replace(pattern, '')
      } else {
        return ''
      }
    },
    colorCreate (m) {
      return colorCreate(m)
    },
    buttonCreate (m) {
      return buttonCreate(m)
    },
    /**
     * アイコン
     * @param {Object} talk 会話データ
     */
    iconUrl (talk) {
      if (talk.speaker === 'my') {
        if (this.templateRobo && this.templateRobo.icon_data) {
          return this.templateRobo.icon_data
        } else {
          return require('@/assets/template/robot.png')
        }
      } else if (talk.speaker === 'other') {
        return require('@/assets/template/human.png')
      }
    },
    /**
     * デモを一番上までスクロールする
     */
    scrollToTop () {
      this.$nextTick(() => {
        const demo = this.$refs.demo_chat
        if (demo) {
          demo.scrollTo({top: 0, behavior: 'smooth'})
        }
      })
    },
    /**
     * デモを一番下までスクロールする
     */
    scrollToBottom () {
      this.$nextTick(() => {
        const demo = this.$refs.demo_chat
        if (demo) {
          demo.scrollTo({top: demo.scrollHeight, behavior: 'smooth'})
        }
      })
    },
    /**
     * デモ会話再生
     */
    demoPlay () {
      if (this.demoTalk.length > 0) {
        this.isDemoTalk = true
        this.getNextTalk()
      }
    },
    /**
     * デモ会話停止
     */
    demoStop () {
      clearTimeout(this.demoId)
      this.isDemoTalk = false
      this.setFirstParts()
      this.scrollToTop()
    },
    /**
     * デモ会話初回パーツ設定
     */
    setFirstParts () {
      this.demoTalk = []
      const firstParts = this.templateRobo.scenarioList.filter(parts => parts.start_flg)
      if (firstParts.length > 0) {
        this.noneStartFlag = false
        this.lastParts = firstParts[0]
        this.getNextTalk()
      } else {
        this.noneStartFlag = true
      }
    },
    /**
     * 次の会話表示
     */
    getNextTalk () {
      if (this.lastParts) {
        const nextTalk = () => {
          // パーツから会話データを作成して、デモ会話に追加する
          this.getPartsContent()

          this.scrollToBottom()

          // 次に続くパーツを取得する
          if (this.lastParts.select.length > 0) {
            // 複数のパーツにつながっていたら、1つ目のパーツを取得する
            const nextNode = this.lastParts.select[0].next_node
            const nextParts = this.templateRobo.scenarioList.filter(parts => parts.beforenode === nextNode)
            if (nextParts.length > 0) {
              this.lastParts = nextParts[0]
            } else {
              // 次のパーツが無ければ終了
              this.isDemoTalk = false
            }
          } else {
            // 次のパーツが無ければ終了
            this.isDemoTalk = false
          }
          // 次の会話取得セット
          if (this.isDemoTalk) {
            clearTimeout(this.demoId)
            this.demoId = setTimeout(nextTalk, 500)
          }
        }
        // 自動会話進行実行
        nextTalk()
      }
    },
    /**
     * 会話内容作成
     */
    getPartsContent () {
      let roboTalk = null
      let personTalk = null
      let sample_message = null
      switch (this.lastParts.status) {
        case PARTS_STATUS.SELECT_MESSAGE:
          // 選択肢ありメッセージパーツ
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            mainmessage: this.lastParts.mainmessage,
            select: this.lastParts.select,
            beforenode: this.lastParts.beforenode,
            disp: 'disp'
          }
          // 訪問者側の会話作成
          personTalk = {
            status: PARTS_STATUS.MESSAGE,
            speaker: 'other',
            mainmessage: this.lastParts.select[0].message,
            beforenode: this.lastParts.beforenode,
            disp: 'disp'
          }
          break
        case PARTS_STATUS.APPLICATION_FORM:
          // 応募フォームパーツ
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            mainmessage: this.lastParts.mainmessage,
            beforenode: this.lastParts.beforenode,
            name: '山田　太郎',
            email: 'demo@robottte.com',
            tel: '09012345678',
            disp: 'disp'
          }
          // 訪問者側の会話作成
          // サンプル応募情報
          sample_message = '【応募内容】\n'
          sample_message += '・お名前：山田　太郎\n'
          sample_message += '・Email：demo@robottte.com\n'
          sample_message += '・TEL：09012345678'
          this.lastParts.select[0].message = sample_message
          personTalk = {
            status: PARTS_STATUS.MESSAGE,
            speaker: 'other',
            mainmessage: this.lastParts.select[0].message,
            beforenode: this.lastParts.beforenode,
            disp: 'disp'
          }
          break
        case PARTS_STATUS.MESSAGE:
          // メッセージのみパーツ
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            mainmessage: this.lastParts.mainmessage,
            beforenode: this.lastParts.beforenode,
            disp: 'disp'
          }
          break
        case PARTS_STATUS.ROBO_CHANGE:
          // ロボ切替パーツ
          // 遷移なし
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            beforenode: this.lastParts.beforenode,
            disp: 'no-disp'
          }
          break
        case PARTS_STATUS.CALENDAR:
          // 日程自動調整パーツ
          // 応募フォームパーツ
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            mainmessage: this.lastParts.mainmessage,
            beforenode: this.lastParts.beforenode,
            disp: 'disp'

          }
          // 訪問者側の会話作成
          let minDate = new Date()
          minDate.setDate(minDate.getDate() - 1)
          const weekday = ['日', '月', '火', '水', '木', '金', '土']
          const afterTime = new Date(minDate.getTime() + (1000 * 60 * 60 * 1))
          const recDate =
            minDate.getMonth() +
            1 +
            '/' +
            minDate.getDate() +
            ' (' +
            weekday[minDate.getDay()] +
            ') ' +
            minDate.getHours() +
            ':' +
            ('00' + minDate.getMinutes()).slice(-2) +
            ' ~ ' +
            afterTime.getHours() +
            ':' +
            ('00' + afterTime.getMinutes()).slice(-2)
          this.lastParts.select[0].message = recDate
          // サンプル応募情報
          personTalk = {
            status: PARTS_STATUS.MESSAGE,
            speaker: 'other',
            mainmessage: this.lastParts.select[0].message,
            beforenode: this.lastParts.beforenode,
            disp: 'disp'
          }
          break
        case PARTS_STATUS.IMAGE:
          // 画像パーツ
          let sample_image = '@/assets/template/no_image.svg'
          if (this.lastParts.image) {
            sample_image = this.lastParts.image
          }
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            mainmessage: this.lastParts.mainmessage,
            beforenode: this.lastParts.beforenode,
            imagePath: sample_image,
            disp: 'disp'
          }
          break
        case PARTS_STATUS.FREE_INPUT:
          // 自由入力パーツ
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            mainmessage: this.lastParts.mainmessage,
            beforenode: this.lastParts.beforenode
          }
          // 訪問者側の会話作成
          personTalk = {
            status: PARTS_STATUS.MESSAGE,
            speaker: 'other',
            mainmessage: 'こんにちは',
            beforenode: this.lastParts.beforenode,
            disp: 'disp'
          }
          break
        case PARTS_STATUS.FAIL_UPLOAD:
          // ファイルアップロードパーツ
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            beforenode: this.lastParts.beforenode,
            disp: 'disp'
          }
          break
        case PARTS_STATUS.RESUME_FORM:
          // 履歴書フォームパーツ
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            beforenode: this.lastParts.beforenode,
            disp: 'disp'
          }
          // 訪問者側の会話作成
          personTalk = {
            status: PARTS_STATUS.MESSAGE,
            speaker: 'other',
            mainmessage: '履歴書を送付',
            beforenode: this.lastParts.beforenode,
            disp: 'disp'
          }
          break
        case PARTS_STATUS.RESTART:
          // 最初からパーツ
          // 遷移なし
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            beforenode: this.lastParts.beforenode,
            disp: 'no-disp'
          }
          break
        case PARTS_STATUS.MAIL_SEND:
          // メール送付パーツ
          // 遷移なし
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            mainmessage: this.lastParts.mainmessage,
            beforenode: this.lastParts.beforenode,
            disp: 'no-disp'
          }
          break
        case PARTS_STATUS.NO_ASSIGN:
          // 欠番
          break
        case PARTS_STATUS.CONDITIONAL_BRANCH:
          // 条件分岐パーツ
          // 遷移なし
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            mainmessage: this.lastParts.mainmessage,
            beforenode: this.lastParts.beforenode,
            disp: 'no-disp'
          }
          break
        case PARTS_STATUS.CHACKBOX:
          // チェックボックスパーツ
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            mainmessage: this.lastParts.mainmessage,
            parameter: this.lastParts.parameter,
            beforenode: this.lastParts.beforenode,
            disp: 'disp'
          }
          // 訪問者側の会話作成
          personTalk = {
            status: PARTS_STATUS.MESSAGE,
            speaker: 'other',
            mainmessage: '・' + this.lastParts.parameter[0].item_message,
            beforenode: this.lastParts.beforenode,
            disp: 'disp'
          }
          break
        case PARTS_STATUS.MOVIE:
          // 動画パーツ
          let sample_movie = ''
          if (this.lastParts.movie) {
            sample_movie = this.lastParts.movie
          }
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            mainmessage: this.lastParts.mainmessage,
            beforenode: this.lastParts.beforenode,
            movie_path: sample_movie,
            disp: 'disp'
          }
          break
        case PARTS_STATUS.PULL_DOWN_SELECT:
          // プルダウンパーツ
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            mainmessage: this.lastParts.mainmessage,
            title: this.lastParts.parameter[0].title,
            item: this.lastParts.parameter[0].items[0].itemName,
            beforenode: this.lastParts.beforenode,
            disp: 'disp'
          }
          // 訪問者側の会話作成
          sample_message = '・' + this.lastParts.parameter[0].title + '：' + this.lastParts.parameter[0].items[0].itemName
          personTalk = {
            status: PARTS_STATUS.MESSAGE,
            speaker: 'other',
            mainmessage: sample_message,
            beforenode: this.lastParts.beforenode,
            disp: 'disp'
          }
          break
        case PARTS_STATUS.SMS_SEND:
          // SMS送付パーツ
          // 遷移なし
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            beforenode: this.lastParts.beforenode,
            disp: 'no-disp'
          }
          break
        case PARTS_STATUS.CAROUSEL_SELECT:
          // カルーセル選択パーツ
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            parameter: this.lastParts.parameter,
            beforenode: this.lastParts.beforenode,
            disp: 'disp'
          }
          // 訪問者側の会話作成
          personTalk = {
            status: PARTS_STATUS.MESSAGE,
            speaker: 'other',
            mainmessage: this.lastParts.parameter.select1.button,
            beforenode: this.lastParts.beforenode,
            disp: 'disp'
          }
          break
        case PARTS_STATUS.FILE_DOWNLOAD:
          // ファイルダウンロードパーツ
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            mainmessage: this.lastParts.mainmessage,
            parameter: this.lastParts.parameter,
            beforenode: this.lastParts.beforenode,
            disp: 'disp'
          }
          break
        case PARTS_STATUS.ANSWER_OUTPUT:
          // 回答出力パーツ
          // 遷移なし
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            parameter: this.lastParts.parameter,
            beforenode: this.lastParts.beforenode,
            disp: 'no-disp'
          }
          break
        case PARTS_STATUS.SEARCH:
          // 検索パーツ
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            parameter: this.lastParts.parameter,
            beforenode: this.lastParts.beforenode,
            disp: 'disp'
          }
          break
        case PARTS_STATUS.PDF_DOWNLOAD:
          // PDFダウンロードパーツ
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            parameter: this.lastParts.parameter,
            beforenode: this.lastParts.beforenode,
            disp: 'disp'
          }
          break
        case PARTS_STATUS.STICKY_NOTE:
          // 付箋パーツ
          // 遷移なし
          // ロボ側の会話作成
          roboTalk = {
            status: this.lastParts.status,
            speaker: 'my',
            parameter: this.lastParts.parameter,
            beforenode: this.lastParts.beforenode,
            disp: 'no-disp'
          }
          break
        default:
          // 不明
          break
      }
      if (roboTalk) {
        this.demoTalk.push(roboTalk)
        // // デモ会話の追加に合わせてスクロールする
        // this.$nextTick(() => {
        //   this.scrollDown()
        // })
      }
      if (personTalk) {
        this.demoTalk.push(personTalk)
        // // デモ会話の追加に合わせてスクロールする
        // this.$nextTick(() => {
        //   this.scrollDown()
        // })
      }
    },
    // ToDo
    // 親要素の画面までスクロールしてしまうので、自動スクロールは保留にする
    // /**
    //  * 最新のメッセージ履歴までスクロール
    //  */
    // scrollDown() {
    //   const nodes = document.querySelectorAll('.chat-timeline')
    //   const last = nodes[nodes.length - 1]
    //   if (!last) return
    //   last.parentNode.scrollTop = last.offsetTop - last.parentNode.offsetTop
    //   last.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
    // },
  }
}
</script>

<style lang="scss" scoped>
.main-container {
  width: 100%;
  .none-start-parts {
    padding-top: 50px;
  }
  .tark-box {
    height: 200px;
    border: solid thin #ccc;
    scroll-behavior: smooth;
    .message-title {
      word-wrap:break-word;
      white-space: pre-wrap;
    }
    .search-end-button {
      display: flex;
      justify-content: flex-end;
    }
    .chat-timeline {
      position: relative;
      min-width: 100%;
      max-width: 100%;
      padding: 10px;
      display: flex;
      align-items: space-between;
      overflow-x: visible;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;

      // アイコン
      .avatar-box {
        position: absolute;
        width: 30px;
        min-width: 30px;
        z-index: 5;
      }
      .avatar-box > img {
        width: 30px;
        height: 30px;
        border-radius: 30px;
        border: 1px solid #f8f8f8;
        box-shadow: 0 1px 1px #ddd;
        background: #fefefe;
        object-fit: cover;
        z-index: 5;
      }
      @mixin message {
        text-align: left;
        padding: 16px;
        max-width: -webkit-fill-available;
        word-wrap: break-word;
        border-radius: 8px;
        font-size: smaller;
        white-space: pre-wrap;
        transition: 0.7s;
        position: relative;
      }
      // 吹き出し
      .balloon-box {
        min-width: 40%;
        max-width: 90%;
        padding: 16px;
        .message-box {
          text-align: left;
          border-radius: 15px;
          transition: 0.7s;
          padding: 8px;
          @mixin message-button {
            display: flex;
            justify-content: left;
            filter: none;
            min-width: 95%;
            max-width: 95%;
            font-size: 10px;
            margin-top: 8px;
            margin-bottom: 10px;
            height: auto;
            overflow: initial;
            white-space: normal;
            text-overflow: ellipsis;
            font-size: smaller;
            text-align: left;
            border-radius: 8px;
          }
          // 選択肢ありメッセージ
          @mixin select-balloon {
            text-align: left;
            padding: 1px;
            width: auto;
            max-width: -webkit-fill-available;
            font-size: medium;
            border-radius: 8px;
            transition: 0.7s;
            @include message;
            .select-button-box {
              width: 100%;
              @include message-button;
            }
          }
          // 応募フォーム
          @mixin application-balloon {
            @include message;
            .application-box {
              width: 100%;
              display: flex;
              flex-direction: column;
              padding: 16px;
              transition: 0.7s;
              background: #fff;
              position: relative;
              border-radius: 8px;
              box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
              .application-header {
                padding: 8px;
                border-radius: 8px;
                background: #f2f2f2;
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
                p {
                  font-size: 14px;
                  font-weight: 600;
                }
              }
              .application-body {
                background: #fff;
                .application-form {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-top: 16px;
                  .application-title {
                    width: 100px;
                    font-size: 13px;
                    text-align: left;
                  }
                  .name-input-size {
                    width: 80%;
                  }
                  .email-input-size {
                    width: 80%;
                  }
                  .tel-input-size {
                    width: 80%;
                  }
                }
                .button-container {
                  padding: 8px;
                  width: 25%;
                  @include message-button;
                }
              }
            }
          }
          // メッセージのみ
          @mixin message-balloon {
            @include message;
          }
          // 日程自動調整
          @mixin calendar-balloon {
            @include message;
            .calendar-box {
              height: auto;
              max-width: 50%;
              transform: scale(0.9);
              display: flex;
              justify-content: center;
            }
          }
          // 画像
          @mixin image-balloon {
            .image-parts {
              background: rgba(0, 0, 0, 0);
              border-radius: 8px;
              max-width: 50%;
              height: auto;
              object-fit: cover;
            }
          }
          // 自由入力
          @mixin free-input-balloon {
            @include message;
            .input-on {
              font-size: 14px;
              width: 100%;
              border-bottom-right-radius: 0;
              border-top-right-radius: 0;
            }
            .send-button {
              width: 40px;
              border-bottom-left-radius: 0;
              border-top-left-radius: 0;
            }
          }
          // ファイルアップロード
          @mixin file-upload-balloon {
            @include message;
            @include message-button;
          }
          // 履歴書フォーム
          @mixin resume-balloon {
            .resume-box {
              padding: 16px;
              box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
              height: 650px;
              border-radius: 8px;
              .resume-header {
                padding: 4px;
                margin-bottom: 8px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                h1 {
                  font-size: 16px;
                  font-weight: 600;
                  text-align: left;
                }
              }
              .form-box {
                width: 95%;
                .name-input-size {
                  width: 100%;
                }
                .radio-input-size {
                  width: 100%;
                }
                .calendar-box {
                  max-width: 30%;
                  transform: scale(0.9);
                  display: flex;
                  justify-content: center;
                }
              }
            }
          }
          // チェックボックス
          @mixin checkbox-balloon {
            @include message;
            @include message-button;
          }
          // 動画
          @mixin movie-balloon {
            .-video {
              height: 160px;
            }
          }
          // プルダウン
          @mixin pulldown-balloon {
            @include message;
            .pulldown-box {
              display: flex;
              flex-wrap: wrap;
              padding: 8px 0;
              overflow: scroll;
              .child-box {
                padding: 0 4px 4px 4px;
                .item-box {
                  font-size: 13px;
                }
              }
            }
          }
          // カルーセル選択
          @mixin carousel-select-balloon {
            .VueCarousel {
              height: auto;
              width: 90%;
              margin: 0 3%;
            }
            .VueCarousel-wrapper,
            .VueCarousel-inner,
            .VueCarousel-slide {
              height: auto;
              width: 90%;
            }
            .VueCarousel-slide .slider-inner {
              height: auto;
              width: 70%;
              margin: 10px;
              background-color: white;
              text-align: center;
              justify-content: center;
              align-items: center;
              color: black;
              border-radius: 20px;
              border: 1px solid #ccc;
              img {
                border-radius: 20px 20px 0 0;
                object-fit: scale-down;
              }
              .contents-container {
                padding: 0 8px;
                .carousel-title {
                  font-size: 12px;
                  height: 18px;
                  text-align: left;
                  margin: 8px 0;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                .carousel-contents {
                  font-size: 12px;
                  height: 18px;
                  margin-bottom: 8px;
                  text-align: left;
                  overflow: auto;
                  text-overflow: ellipsis;
                  white-space: pre-wrap;
                }
              }
            }
            .VueCarousel-dot-container {
              margin-top: -20px;
            }
            .btn-disabled {
              background: rgb(240, 240, 240);
              color: gray;
              border: solid 2px gray;
            }
            .btn-disabled:hover {
              background: rgb(240, 240, 240);
                color: gray;
            }
            // > ボタン
            /deep/ .VueCarousel-navigation-next {
              font-size: 2rem;
            }
            // < ボタン
            /deep/ .VueCarousel-navigation-prev {
              font-size: 2rem;
            }
          }
          // ファイルダウンロード
          @mixin file-download-balloon {
            @include message;
            @include message-button;
          }
          // 検索
          @mixin search-balloon {
            width: 100%;
            padding: 8px;
            @include message;
            .search-box {
              display: flex;
              min-height: 200px;
            }
          }
          // PDFダウンロード
          @mixin pdf-download-balloon {
            @include message-button;
          }
          // 企業側メッセージ
          .my-message-box {
            flex-direction: row;
            .my-box {
              flex-direction: row;
            }
            @include select-balloon;
            @include application-balloon;
            @include message-balloon;
            @include calendar-balloon;
            @include image-balloon;
            @include free-input-balloon;
            @include file-upload-balloon;
            @include resume-balloon;
            @include checkbox-balloon;
            @include movie-balloon;
            @include pulldown-balloon;
            @include carousel-select-balloon;
            @include file-download-balloon;
            @include search-balloon;
            @include pdf-download-balloon;
          }
          // 訪問者側メッセージ
          .other-message-box {
            flex-direction: row-reverse;
            .other-box {
              flex-direction: row-reverse;
            }
            @include select-balloon;
            @include application-balloon;
            @include message-balloon;
            @include calendar-balloon;
            @include image-balloon;
            @include free-input-balloon;
            @include file-upload-balloon;
            @include resume-balloon;
            @include checkbox-balloon;
            @include movie-balloon;
            @include pulldown-balloon;
            @include carousel-select-balloon;
            @include file-download-balloon;
            @include search-balloon;
            @include pdf-download-balloon;
          }
        }
      }
    }
    .my-timeline {
      flex-direction: row;
    }
    .other-timeline {
      flex-direction: row-reverse;
    }
  }
}
/* Animation */
@for $i from 0 through 10 {
  $enter-delay: 300ms;
  &.slide-button-#{$i} {
    // opacity: 1;
    animation-duration: #{200ms * ($i + 1)};
    animation-name: slide-in;
  }
}
@keyframes slide-in {
  0% {
    // opacity: 0;
    transform: scale(0) translateX(300px);
  }
  70% {
    // opacity: 0;
    transform: scale(0) translateX(300px);
  }
  100% {
    // opacity: 1;
    transform: scale(1) translateX(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components2/Robo/modal/organisms/TemplateRoboScenarioDemo.vue